import React from 'react';
import 'assets/css/toggle.css';
const Toggle = ({ name, handleChange, checked, value, color }) => {
  return (
    <label className="switch" style={color ? { '--primary-dark-color': color, '--inactive-color': 'red' } : undefined}>
      <input type="checkbox" name={name} onChange={handleChange} value={value} checked={checked} />
      <span className="slider round" />
    </label>
  );
};

export default Toggle;
